import { HttpClient } from "../httpClient";
import BillingRate from "../models/billingRate";
import { DataResponse } from "../responses/baseResponse";
import BillingRateResponse from "../responses/billingRateResponse";
import BillingRateRequest from "../requests/billingRateRequest";
import RejectWithFeedbackRequest from '../requests/rejectWithFeedbackRequest';

const httpClient = new HttpClient();

export const getBillingRateById = async (id: any) => {
  return httpClient.get<DataResponse<BillingRate>>({
      url: `/v1/BillingRates/${id}`,
      requiresToken: true
  });
}

export const getBillingRates = async () => {
    return httpClient.get<DataResponse<BillingRate[]>>({
        url: '/v1/BillingRates',
        requiresToken: true
    });
}

export const getBillingRatesByDistrictId = async (districtId: number) => {
  return httpClient.get<DataResponse<BillingRate[]>>({
      url: `/v1/BillingRates/ByDistrict/${districtId}`,
      requiresToken: true
  });
}

export const getPastBillingRates = async () => {
    return httpClient.get<DataResponse<BillingRate[]>>({
        url: '/v1/BillingRates/Past',
        requiresToken: true
    });
}

export const getActiveBillingRates = async () => {
    return httpClient.get<DataResponse<BillingRate[]>>({
        url: '/v1/BillingRates/Active',
        requiresToken: true
    });
}

export const getScheduledBillingRates = async () => {
    return httpClient.get<DataResponse<BillingRate[]>>({
        url: '/v1/BillingRates/Scheduled',
        requiresToken: true
    });
}

export const getPendingBillingRatesByDistrictId = async (districtId: number) => {
  return httpClient.get<DataResponse<BillingRate[]>>({
      url: `/v1/BillingRates/${districtId}/Pending`,
      requiresToken: true
  });
}

export const getPendingBillingRatesByDirectorId = async (directorId: number) => {
  return httpClient.get<DataResponse<BillingRate[]>>({
      url: `/v1/Directors/${directorId}/BillingRates`,
      requiresToken: true
  });
}

export const getPendingBillingRatesByUserId = async (userId: number) => {
  return httpClient.get<DataResponse<BillingRate[]>>({
      url: `/v1/Directors/User/${userId}/BillingRates/Pending`,
      requiresToken: true
  });
}

export const createBillingRate = async (BillingRaterequest: BillingRateRequest) => {
    return httpClient.post<BillingRateResponse>({
      url: '/v1/admin/BillingRates',
      payload: BillingRaterequest,
      requiresToken: true,
    });
  };
  
  export const updateBillingRate = async (
    BillingRateId: number,
    BillingRaterequest: BillingRateRequest
  ) => {
    return httpClient.put<BillingRateResponse>({
      url: `/v1/admin/BillingRates/${BillingRateId}`,
      payload: BillingRaterequest,
      requiresToken: true,
    });
  };
  
  export const deleteBillingRate = async (BillingRateId: number, rejectRequest: RejectWithFeedbackRequest) => {
    return httpClient.post<BillingRateResponse>({
      url: `/v1/admin/BillingRates/${BillingRateId}`,
      payload: rejectRequest,
      requiresToken: true,
    });
  };

  export const approveBillingRateById = async (id: number) => {
    return httpClient.put<DataResponse<boolean>>({
      url: `/v1/BillingRates/${id}/Approve`,
      payload: { id },
      requiresToken: true,
    });
  };

  export const rejectBillingRateById = async (id: number) => {
    return httpClient.put<DataResponse<boolean>>({
      url: `/v1/BillingRates/${id}/Reject`,
      payload: { id },
      requiresToken: true,
    });
  };